import Splitting from 'splitting';

const textSlideItems = document.querySelectorAll('[data-text-slide]');

textSlideItems.forEach((item) => {
  const splitting = Splitting({
    target: item,
    by: 'lines',
  });

  splitting[0].words.forEach((word) => {
    const span = document.createElement('SPAN');
    span.classList.add('word-inner');
    span.innerHTML = word.innerHTML;
    word.innerHTML = '';
    word.appendChild(span);

    const closestLink = word.closest('a');

    if (closestLink) {
      const lineIndex =
        getComputedStyle(closestLink).getPropertyValue('--line-index');
      console.log(lineIndex);
      if (!lineIndex)
        closestLink.style.setProperty(
          '--line-index',
          getComputedStyle(word).getPropertyValue('--line-index')
        );
    }
  });
});
